<template>
  <div>
    <p>{{ label }} messaging response (<a :href="link">Message Response</a>)</p>
    <div class="object-details">
      <span v-html="details.display_name"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "MessagingTrigger",
  props: {
    details: {
      type: Object,
      default: function () {
        return {};
      }
    },
    label: {
      type: String,
      default: "Related to"
    }
  },
  computed: {
    link() {
      return `${this.$config.baseUrl}/admin/study/${this.$config.studyId}/messaging/triggers/${this.details.id}/edit`;
    }
  },
}
</script>

<style scoped>

</style>